import { Ability } from "@casl/ability";
import {
  COMMIT_SET_USER_LOGIN,
  MUTATION_DO_LOGOUT
} from "./modules/users/constants";

export const ability = new Ability();

export const abilityPlugin = store => {
  const user = store.users && store.users.userInfo;
  const userPermissions =
    user && user.permissions && user.permissions.length ? user.permissions : [];
  ability.update(userPermissions);

  return store.subscribe(mutation => {
    switch (mutation.type) {
      case COMMIT_SET_USER_LOGIN:
        ability.update(mutation.payload.permissions);
        break;
      case MUTATION_DO_LOGOUT:
        ability.update([]);
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/ability.js